import styled from 'styled-components';

export const PolicyWrapper = styled.div`
.has-text-align-justify{
    text-align:justify;
}
.has-text-align-left{
    text-align:left;
}
`;
